import { get as fetch } from '../../shared/utils/fetch.util'

export const get = () => fetch('/v1/app-users/me/importrequests')

export const getMyListingsV3 = query => fetch('/v3/users/me/listings', query).then((res) => res.data)